import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../AuthContext';

function Register() {

    const [formData, setFormData] = useState({
        name: '',
        password: '',
        email: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post('https://api.eazyworldehsengineering.com/api/auth/register', formData, {
                headers: { 'Content-Type': 'application/json' },
            });
            const data = response.data;
            console.log(data)
            navigate('/login');

            // Reset form and show success message
            setFormData({ username: '', password: '' });
        } catch (error) {
            if (error.response) {
                setError(error.response.data.error);
            } else {
                setError('An error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="register-page">
            <div className="register-box">
                <div className="card">
                    <div className="card-header text-center">
                        <span
                            style={{
                                display: 'inline-flex',
                                width: '52px',
                                height: '52px',
                                borderRadius: '14px',
                                background: 'linear-gradient(135deg, #4f46e5, #818cf8)',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '14px',
                            }}
                        >
                            <i className="fas fa-user-plus" style={{ color: '#fff', fontSize: '1.3rem' }}></i>
                        </span>
                        <h1 style={{ fontSize: '1.4rem', margin: 0 }}>Eazyworld Engineering</h1>
                    </div>
                    <div className="card-body">
                        <p className="login-box-msg">Register a new membership</p>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="input-group mb-3">
                                <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Full name" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-user"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Email" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" name="password" value={formData.password} onChange={handleChange} className="form-control" placeholder="Password" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8">
                                    <div className="icheck-primary">
                                        <input type="checkbox" id="agreeTerms" name="terms" value="agree" />
                                        <label for="agreeTerms">
                                            I agree to the <a href="#">terms</a>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                                        {loading ? 'Registering...' : 'Register'}
                                    </button>
                                </div>

                            </div>
                        </form>

                        <a href="/login" className="d-block text-center mt-3">I already have a membership</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register